export const THEME_NAME_HIGH_CONTRAST = 'highcontrast';
export const THEME_NAME_DEFAULT = 'default';
